import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { LinearProgress } from '@mui/material';
import TopBar from '../components/common/TopBar';
import ErrorMsg from '../components/common/ErrorMsg';
import usePaginatedDocumentsManifest from '../components/hooks/usePaginatedDocumentsManifest';

// Allow the user to access an extraction in a batch given the document id
const ReviewPageByDocId = () => {
  const { dpid, id, documentId } = useParams<{
    dpid: string;
    id: string;
    documentId: string;
  }>();

  const navigate = useNavigate();

  const { data: allDocumentData, isPending: documentLoading } = usePaginatedDocumentsManifest({
    limit: 1,
    dpId: dpid!,
    defaultPage: 0,
    includeId: documentId,
  });

  const documentData = allDocumentData?.results[0];

  documentData?.extractions?.forEach((extraction) => {
    if (extraction.extraction_batch === id) {
      navigate(`/data-pools/${dpid}/extraction-batch/${id}/review/${extraction.id}`);
    }
  });

  if (!allDocumentData?.results || documentLoading) return <LinearProgress />;

  return <LinearProgress />;
};

export default ReviewPageByDocId;
